// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"29160735","419":"9a9fb3f6","439":"06670d90","458":"8fb01112","459":"c5eaafed","774":"a858baef","858":"409d378b"}[chunkId] + ".chunk.js";
};